<template>
  <section class="call-to-action text-white text-center">
    <div class="overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-9 mx-auto">
          <h2 class="mb-4">Get Started Today</h2>
          <a class="btn btn-primary btn-lg" href="https://cloud.reenigne.net/#/signup">
            Sign Up
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'footer-cta'
}
</script>

<style scoped class="scss">
.form-enter, .form-leave-to {
  transform: translateY(-3vh);
  opacity: 0;
}

.form-enter-active, .form-leave-active {
  transition: all 0.3s;
}
</style>
